/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useDeleteApiKeyMutation } from "~/generated/graphql";
import { showError } from "~/services/toast";
import { removeFromApolloCache } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useDeleteApiKey({ onSuccess }: Props) {
  const [deleteApiKeyMutation, { client, ...rest }] = useDeleteApiKeyMutation({
    onCompleted: (data) => {
      if (data.removeApiKey) {
        onSuccess();
      } else {
        showError();
      }
    },
  });

  async function deleteApiKey(id: string) {
    await deleteApiKeyMutation({
      variables: {
        apiKeyId: id,
      },
    });

    removeFromApolloCache(client.cache, `ApiKey:${id}`, "apiKeys");
  }

  return [deleteApiKey, { client, ...rest }] as const;
}
